import { useWeb3React } from '@web3-react/core'
import { InjectedConnector } from '@web3-react/injected-connector'
import { Button } from 'components'
import { formatAddress } from 'utils'
import { Box } from './Box'
import { Text } from './Typography'

const injected = new InjectedConnector({
  supportedChainIds: [1, 4],
})

export const ConnectInterface = () => {
  const { account, activate, deactivate } = useWeb3React()
  return (
    <Box justifyContent="center" marginBottom="12px" alignItems="center" flexDirection="row">
      {account && (
        <Text style={{ marginRight: '12px' }} weight="regular" color="WHITE_80" size="s">
          {formatAddress(account)}
        </Text>
      )}
      {!account ? (
        <Button
          onClick={() => activate(injected, (err) => console.error('web3 activate', err))}
          variant="translucent"
          text="Connect"
          size="s"
        />
      ) : (
        <Button size="s" onClick={deactivate} variant="translucent" text="Disconnect" />
      )}
    </Box>
  )
}
